import { loginApi } from '../../setup/setupApi';
import { AskFields, EmailValidations, MagicLink } from './types';

const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
  Authorization: string;
};

export const getEmailValidation = (projectId: string): Promise<EmailValidations> =>
  loginApi.get(`projects/${projectId}/email_validation`).then((res) => res.data);

export const setEmailValidation = (
  projectId: string,
  settings: EmailValidations
): Promise<EmailValidations> =>
  loginApi.put(`projects/${projectId}/email_validation`, settings).then((res) => res.data);

export const getAskFields = (projectId: string): Promise<AskFields> =>
  loginApi.get(`projects/${projectId}/ask_fields`).then((res) => res.data);

export const setAskFields = (projectId: string, askFields: AskFields): Promise<AskFields> =>
  loginApi.put(`projects/${projectId}/ask_fields`, askFields).then((res) => res.data);

export const getMagicLink = (projectId: string): Promise<MagicLink> =>
  loginApi.get(`projects/${projectId}/magic_link`).then((res) => res.data);

export const setMagicLink = (projectId: string, magicLink: MagicLink): Promise<MagicLink> =>
  loginApi.post(`projects/${projectId}/magic_link`, magicLink).then((res) => res.data);

export const getWelcomeEmail = (projectId: string): Promise<boolean> =>
  loginApi
    .get(`projects/${projectId}/welcome_email`, {
      headers: {
        Authorization: 'undefined',
        'X-SERVER-AUTHORIZATION': Authorization
      }
    })
    .then(() => true);

export const setWelcomeEmail = (projectId: string): Promise<boolean> =>
  loginApi.post(`projects/${projectId}/welcome_email`, null).then(() => true);

export const disableWelcomeEmail = (projectId: string): Promise<boolean> =>
  loginApi.delete(`projects/${projectId}/welcome_email`).then(() => true);
